/* ========================================================================
   Mountain Valley Antlers — Antlers by Species
   Interactive behaviors
   ------------------------------------------------------------------------
   1. Animate hardness bars from 0 → their CSS-variable target width when
      their parent section scrolls into view.
   2. Respects prefers-reduced-motion (skips the animation entirely).
   ======================================================================== */
(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAllBars() {
    document.querySelectorAll('.bar-fill').forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  function init() {
    // No IntersectionObserver → just show everything filled.
    if (reducedMotion || typeof IntersectionObserver === 'undefined') {
      revealAllBars();
      return;
    }

    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.35,
      rootMargin: '0px 0px -10% 0px'
    });

    document.querySelectorAll('.bar-fill').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
